import React, { Component } from 'react'
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import { isDesktop } from "react-device-detect";
import moment from "moment";

//Miscellaneous 
// import { formValidation, clearFormValidation } from "../../hoc/Shared/utility";
import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import MobileDepositHistory from "./MobileDepositHistory";
import { default as ReactSelect } from "react-select";

//Components 
// import NumberInput from "../../components/Input/NumberInput/NumberInput";
// import StringInput from "../../components/Input/StringInput/StringInput";
// import Select from "../../components/Input/Select/Select";
import DataTable from "../../components/Datatable/DataTable";
import Button from "../../components/Button/Button";
import DateTimePicker from "../../components/DateTimePicker/DateTimePicker";

// Actions
import * as actions from "../../store/ducks/delegateDeposit/actions";
import { Fade/*, Reveal*/ } from "react-awesome-reveal";

//Icons
// import { keyframes } from "@emotion/react";
import { Icon } from "@iconify/react";

const filterDate = [
    { id: "filterToday", value: "0", label: "today" },
    { id: "filterYtd", value: "1", label: "yesterday" },
    { id: "filter7Day", value: "7", label: "last-7-days" },
    { id: "filter30Days", value: "30", label: "last-30-days" },
];

// const options = [
//     { value: "all", label: "All" },
//     { value: "success", label: "Successful" },
//     { value: "fail", label: "Failed" },
// ];
   

class DepositHistory extends Component 
{
    constructor(props) 
    {
        super(props);
        const initLoad = this.props.delegateDepositShowInitialLoading.filter(item => item.id === "deposit_history");
        const initialLoading = initLoad[0].loading;
        
        if (initialLoading) 
        {
            this.state =
            {
                currentPage: "deposit_history",
                currentFilterDate: 0,

                startDate: moment().format("YYYY-MM-DD"),
                endDate: moment().format("YYYY-MM-DD"),
                transaction_date: '',
                memberId: '',

                /* datatables / pagination */
                activePage: Number(process.env.REACT_APP_DATATABLE_PAGE),
                limit: Number(process.env.REACT_APP_DATATABLE_LIMIT),
                totalRecords: 0,

                /* api result array */
                data: [],
                total: [],
                downline: [],

                /* skeleton loading */
                loading: true,
                dates: null,

                /* mobile */
                showDateSelect: false,
                showDate: '',
                selectedDate: '',

                selectedOption: null,
            };

            this.props.setDelegateDepositLocalState(this.state);
        }
        else 
        {
            this.state = this.props.delegateDepositHistoryLocalState;
        }

        this.onInputChangeHandler = this.onInputChangeHandler.bind(this);
    }

    componentDidMount() 
    {
        const initLoad = this.props.delegateDepositShowInitialLoading.filter(item => item.id === "deposit_history");
        const initialLoading = initLoad[0].loading;

        if(initialLoading) 
        {
            this.props.funcGetDropDown();
            const listingArr = this.getFilterArray();
            this.props.funcGetList(listingArr);
            this.props.setDelegateDepositInitialLoading(this.state.currentPage);
        }     
    }

    componentWillUnmount() 
    {
        this.props.setDelegateDepositLocalState(this.state);
    }
    
    shouldComponentUpdate(nextProps, nextState) 
	{
		const { t } = this.props;
        if (nextProps.dropDown !== this.props.dropDown && nextProps.dropDown !== undefined) 
        {
            if (nextProps.dropDown.responseCode === 200 && nextProps.dropDown.msgType === "success") 
            {
                this.setState({
                    downline: nextProps.dropDown.data.downline,
                });
            }
        }
        
		if (nextProps.rs !== this.props.rs && nextProps.rs !== undefined) 
        {
            if (nextProps.rs.responseCode === 200 && nextProps.rs.msgType === 'success') 
            {
                this.setState({
                    data: nextProps.rs.data.result.row,
                    totalRecords: nextProps.rs.data.result.pagination.total_record,
                    loading: false,
                    total: nextProps.rs.data.total,
                    disableSearchButton: false,
                });
            }
        }

        return true;
	}

    getFilterArray = () => 
    {
        const listingArr = {};
        listingArr.page = this.state.activePage;
        listingArr.limit = this.state.limit;
        listingArr.order = JSON.stringify(this.state.order);
        listingArr.start_date = this.state.startDate;
        listingArr.end_date = this.state.endDate;
        listingArr.member_id = this.state.memberId;
        return listingArr;
    }

    datatablesChangeHandler = (val, act) => 
    {
    this.setState({
            data: [],
            loading: true,
            [act]: val
        }, () => 
        {
            const listingArr = this.getFilterArray();
            this.props.funcGetList(listingArr);
        });
    }
    
    onInputChangeHandler = (event) => 
	{
        // console.log(event.target.name+' | '+event.target.value)
		if (event.target.id === 'transaction_date') 
        {
            // console.log(event.target.id+' | '+event.target.value)
            const date = (event.target.value !== '') ? event.target.value.split(" - ") : null;
            this.setState({
                startDate: (date[0]) ? moment(date[0]).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"),
                endDate: (date[1]) ? moment(date[1]).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"),
                transaction_date: event.target.value,
            });
            
            const startDate = moment(this.state.startDate);
            const endDate = moment(this.state.endDate);
            const diff = endDate.diff(startDate, 'days');

            // Only allow to get data between 3 months
            this.setState({
                disableSearchButton: (diff > 92) ? true : false,
            });
        }
        else 
        {
            this.setState({
                [event.target.name]: event.target.value,
            });
        }
	}

    onChangeDateHandler = (value) => 
    {
        if (this.state.showDate === 'startDate') 
        {
            this.setState({
                startDate: `${value.years}-${value.months}-${value.days}`,
            })
        }
        else if (this.state.showDate === 'endDate') 
        {
            this.setState({
                endDate: `${value.years}-${value.months}-${value.days}`,
            })
        }
    }

    filterDayRange = (val) => 
    {
        // let days = Number(event.target.value);
        let days = val;
        let startDate = moment().subtract(days, "days").format("YYYY-MM-DD");
        let endDate = moment().format("YYYY-MM-DD");
        let transactionDate = `${moment(startDate).format("MM/DD/YYYY")} - ${moment(endDate).format("MM/DD/YYYY")}`;

        this.setState({
            startDate: startDate,
            endDate: endDate,
            transaction_date: transactionDate,
            data: [],
            loading: true,
        }, () => 
        {
            let startDate = moment(this.state.startDate);
            let endDate = moment(this.state.endDate);
            let dayRange = endDate.diff(startDate, 'days');
            let disableButton = null;

            if (!startDate.isSameOrBefore(endDate) || !endDate.isSameOrAfter(startDate) || dayRange > 92) 
            {
                disableButton = true;
            }
            else 
            {
                disableButton = false;
                const listingArr = this.getFilterArray();
                this.props.funcGetList(listingArr);
            }
            this.setState({
                disableSearchButton: disableButton
            });
        });
    }

    onChangeFilterDateHandler = (value, e) => 
    {
        this.setState({
            currentFilterDate: value
        });
    }

    toggleShowDateSelect = (e, show) => 
    {
        if (this.state.showDateSelect === false) {
            document.body.classList.add('modal-open');
        } else {
            document.body.classList.remove('modal-open');
        }
        this.setState({
            showDateSelect: !this.state.showDateSelect,
        });
        if (show === 'startDate') {
            this.setState({
                showDate: 'startDate',
                selectedDate: this.state.startDate,
                disableSearchButton: false,
            })
        } else if (show === 'endDate') {
            this.setState({
                showDate: 'endDate',
                selectedDate: this.state.endDate,
                disableSearchButton: false,
            })
        }
    }

    searchHandler = () => 
    {
        this.setState({
            activePage: 1,
            data: [],
            loading: true,
            disableSearchButton: true
        }, () => 
        {
            const listingArr = this.getFilterArray();
            this.props.funcGetList(listingArr);
        });
    }

    onResetHandler = () => 
    {
        this.setState({
            activePage: 1,
            data: [],
            loading: true,
            disableSearchButton: true,
            currentFilterDate: 0,
            startDate: moment().format("YYYY-MM-DD"),
            endDate: moment().format("YYYY-MM-DD"),
            transaction_date: "",
            memberId: "",

        }, () => 
        {
            const listingArr = this.getFilterArray();
            this.props.funcGetList(listingArr);
        });

        setTimeout(() => this.setState({ spin: false }), 2000);
    }

    handleChange = (selectedOption) => 
    {
        this.setState({ selectedOption }, () => console.log(`Option selected:`, this.state.selectedOption));
    }

    memberChangeHandler = (event) => 
    {
		this.setState({
			memberId: event.id,
		});
	}

    imageImport = (r) => 
    {
        let images = {};
        r.keys().map((item, index) => 
        {
            return (images[item.replace("./", "")] = r(item)["default"]);
        });
        return images;
    }

    render() 
    {
        const { t } = this.props;
        const resetIcon = this.imageImport(require.context("../../assets/images/icons", false, /\.(png|jpe?g|svg)$/));
        const columns = 
        [
            { text: t('delegate-deposit.date'), dataField: 'create_date' },
            { text: t('delegate-deposit.order-id'), dataField: 'order_id' },
            { text: t('delegate-deposit.member'), dataField: 'member' },
            { text: t('delegate-deposit.amount'), dataField: 'amount' },
        ];
        let downlineList = [];
        
        if (this.state.downline) 
        {
            this.state.downline.map((val, idx) => 
            {
                return downlineList.push({
                    id: val.id,
                    label: val.username,
                    key: idx,
                });
            });
        }
        // const fadeUp = keyframes`
        //     from {
        //     opacity: 0;
        //     transform: translate3d(0, 50px ,0);
        //     }

        //     to {
        //     opacity: 1;
        //     transform: translate3d(0, 0, 0);
        //     }
        // `;

        return (
            <Auxiliary>
                {isDesktop ? (
                    <div className="pd-content ">
                        <div className="filters-col history-n-filter">
                            <div className="filters-tp-panel row">
                                <div className="filters-tp-col col-5">
                                    {/* <label className="col-form-label">{t('delegate-deposit.member')}:</label> */}
                                    <label className="col-form-label">{t('delegate-deposit.member')}:</label>
                                    <div className="input-group">
                                        {/* <StringInput
                                            id="member"
                                            name="member"
                                            className={`form-control`}
                                            value={this.state.member}
                                            placeholder='Member'
                                            onChange={(event) => this.onInputChangeHandler(event)}
                                            onSearchPress={(evt) => evt.key === "Enter" && this.searchHandler()}
                                        /> */}
                                        <ReactSelect
                                            id='memberId'
                                            name='memberId'
                                            classNamePrefix="react-select"
                                            className={`form-control p-0 border-0`}
                                            placeholder={t('delegate-deposit.select-member')}
                                            options={downlineList}
                                            onChange={this.memberChangeHandler}
                                            value={(this.state.memberId !== '') ? downlineList[this.state.memberId] : ''}
                                        />
                                        {/* <div className="invalid-feedback">{this.state.formError && this.state.errorMsg.memberId}</div> */}
                                    </div>
                                </div>
                                <div className="filters-tp-col col-5">
                                    <label className="col-form-label">{t('delegate-deposit.time')}: </label>
                                    <div className="input-group right">
                                        <DateTimePicker
                                            id="transaction_date"
                                            name="transaction_date"
                                            className="form-control"
                                            autoUpdateInput={true}
                                            autoApply={true}
                                            format="MM / DD / YYYY"
                                            value={this.state.transaction_date}
                                            onChange={(event) => this.onInputChangeHandler(event)}
                                        />
                                        <span className="input-group-text">
                                            <Icon icon="uil:calendar-alt" />
                                        </span>
                                </div>
                                </div>
                            </div>
                            <div className="filters-bt-panel">
                                <div className="filters-bt-col">
                                    <label className="col-form-label">{t('history.date')}:</label>
                                    <div className="filters-group">
                                        {filterDate &&
                                            filterDate.map((item, index) => (
                                                <div className="form-check form-check-inline filter" key={index}>
                                                    <input
                                                        className="btn-check"
                                                        type="radio"
                                                        name="filterDate"
                                                        id={item.id}
                                                        value={item.value}
                                                        defaultChecked={index === 0}
                                                        checked={index === this.state.currentFilterDate}
                                                        onClick={(e) => this.onChangeFilterDateHandler(index, e)}
                                                    />
                                                    <label className="btn form-check-label" htmlFor={item.id} style={{ maxWidth: '75px' }} onClick={() => this.filterDayRange(item.value)}>
                                                        {t(`history.${item.label}`)}
                                                    </label>
                                                </div>
                                            ))}
                                    </div>
                                </div>
                                <div className="filters-bt-col">
                                    {/* <label className="col-form-label">{t('history.time')}:</label> */}
                                    {/* <label className="col-form-label">Betting Time :</label> */}
                                    {/* <div className="input-group right">
                                        <DateTimePicker
                                            id="transaction_date"
                                            name="transaction_date"
                                            className="form-control"
                                            autoUpdateInput={true}
                                            autoApply={true}
                                            format="MM/DD/YYYY"
                                            value={this.state.transaction_date}
                                            onChange={(event) => this.onInputChangeHandler(event)}
                                        />
                                        <span className="input-group-text">
                                            <Icon icon="uil:calendar-alt" />
                                        </span>
                                    </div> */}
                                    <Button
                                        typeButton="button"
                                        classValue="btn btn-gradient-blue"
                                        idValue="search"
                                        buttonName={t('global.check')}
                                        clicked={() => this.searchHandler()}
                                        disabled={this.state.disableSearchButton}
                                    />
                                    <div className="reset-btn">
                                        <img className={`${this.state.spin ? "spin" : ""} `} src={resetIcon["rotate-icon.svg"]} alt="reset" onClick={this.onResetHandler} />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="tab-pane fade show active" id="banking-details" role="tabpanel" aria-labelledby="banking-tab">
                            <span className="mx-2">&nbsp;</span>
                            <Fade duration={1000} triggerOnce>
                                <DataTable
                                    keyField="no"
                                    data={this.state.data}
                                    columns={columns}
                                    activePage={this.state.activePage}
                                    limit={this.state.limit}
                                    totalItems={this.state.totalRecords}
                                    paginationHandler={(val) => this.datatablesChangeHandler(val, "activePage")}
                                    loading={this.state.loading}
                                    hideSearchBar={true}
                                    hideTotalRecords={true}
                                    classValue="pd-table"
                                    component="delegate-deposit-history"
                                />
                            </Fade>
                        </div>
                    </div>
                ) : (
                    <MobileDepositHistory
                        {...this.state} 
                        onInputChangeHandler={this.onInputChangeHandler}
                        onChangeDateHandler={this.onChangeDateHandler}
                        onChangeFilterDateHandler={this.onChangeFilterDateHandler}
                        datatablesChangeHandler={this.datatablesChangeHandler}
                        filterDayRange={this.filterDayRange}
                        searchHandler={this.searchHandler}
                        onResetHandler={this.onResetHandler}
                        toggleShowDateSelect={this.toggleShowDateSelect}
                        submitHandler={this.submitHandler}
                        columns={columns}
                        downlineList={downlineList}
                        filterDate={filterDate}

                        {...this.props}
                        showDateHandler={this.props.showDateHandler} 
                        offDateHandler={this.props.offDateHandler}  
                        memberChangeHandler={this.memberChangeHandler}
                        handleChange={this.handleChange}                     
                    />
                )
                }
            </Auxiliary>
        )
    }
}

const mapStateToProps = (state) => 
{
	const { delegateDeposit } = state;
	return {
        rs: delegateDeposit.rs,
        delegateDepositShowInitialLoading: delegateDeposit.delegate_deposit_initial_loading,
        delegateDepositHistoryLocalState: delegateDeposit.delegate_deposit_history_local_state,
        dropDown: state.delegateDeposit.dropDown,
	};
};

const mapDispatchToProps = (dispatch) => 
{
	return {
        setDelegateDepositLocalState: (data) => dispatch(actions.setDelegateDepositLocalState(data)),
        setDelegateDepositInitialLoading: (data) => dispatch(actions.setDelegateDepositInitialLoading(data)),
        funcGetList: (filter) => dispatch(actions.getList(filter)),
        funcGetDropDown: (filter) => dispatch(actions.getDropDown(filter)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces("translation")(DepositHistory));